import { NotePencil, X } from "@phosphor-icons/react";
import { useState } from "react";
import NotesPanel from "./NotesPanel";

interface NoteButtonProps {
  contextType: string;
  contextId: string | number;
  label?: string;
}

export default function NoteButton({ contextType, contextId, label }: NoteButtonProps) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-5 right-5 z-50 bg-surface-1 border border-white/[0.08] hover:border-white/15 text-white/50 hover:text-white p-3 rounded-xl shadow-lg transition-all cursor-pointer flex items-center gap-2"
        title={isOpen ? "Kapat" : "Not Al"}
      >
        {isOpen ? (
          <X size={20} weight="bold" />
        ) : (
          <>
            <NotePencil size={20} weight="bold" />
            <span className="text-sm font-medium pr-0.5">Not Al</span>
          </>
        )}
      </button>

      {isOpen && (
        <NotesPanel
          contextType={contextType}
          contextId={contextId}
          label={label}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  );
}
